/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-07-09 17:27:09
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-07-09 17:37:52
 */
import React from 'react'

// Props 类型
interface VideoThumbnailProps {
  src: string
  alt: string
  size?: 'normal' | 'small'
}

/**
 * 视频缩略图组件
 * @param {object} props - 组件属性
 * @param {string} props.src - 缩略图URL
 * @param {string} props.alt - 替代文本
 * @param {string} props.size - 尺寸，可选值：'normal'或'small'，默认为'normal'
 * @returns {JSX.Element} - 视频缩略图组件
 */
const VideoThumbnail: React.FC<VideoThumbnailProps> = ({ src, alt, size = 'normal' }) => {
  return (
    <div className="video-thumbnail">
      <img src={src} alt={alt} className="thumbnail" />
      <div
        className={
          size === 'small' ? 'video-play-icon-small' : 'video-play-icon'
        }
      >
        ▶
      </div>
    </div>
  )
}

export default VideoThumbnail
